import { createAction, props } from '@ngrx/store';
import type { PaymentRow } from '../../payment-history/payment-history.interface';

export const loadPaymentHistoryList = createAction('[Payment History] Load Payment History');

export const loadPaymentHistorySuccess = createAction('[Payment-history] Load Success',
    props<{ paymentHistory: Array<PaymentRow> }>());

export const loadPaymentHistoryError = createAction('[Payment-history] Load Error',
    props<{ error: any }>());
